import React, { useMemo } from "react";
import { useHistory } from "react-router-dom";
import CRUDTable from "../CRUDTable";
import { planDocumentCRUD } from "../../../http";
import { PLAN_DOCUMENT_ROUTE } from "../../../routes";
import { formatDateAsDate, formatDateAsMonthYear } from "../../../functions/formatters";
import { getPlanStateLabel } from "../../../models/planStateIds";
import { getFilials } from "../../../redux/actions";

export default function PlanDocumentCRUDTable({ ...props }) {
  const { push } = useHistory();

  const columns = useMemo(
    () => [
      {
        title: "Id",
        dataIndex: "id",
        key: "id",
        width: 80,
        fixed: "left",
      },
      {
        title: "Статус",
        dataIndex: "stateId",
        key: "stateId",
        width: 200,
        render: (_, row) =>
          row?.state?.name || getPlanStateLabel(row?.stateId, "—"),
      },
      {
        title: "Год / период",
        dataIndex: "createdAt",
        key: "period",
        width: 140,
        render: (_, row) => {
          // Берём месяц и год создания документа
          const created = row?.createdAt ?? row?.CreatedAt;
          return created ? formatDateAsMonthYear(created) : "—";
        },
      },
      {
        title: "Филиал",
        dataIndex: "filial",
        key: "filial",
        width: 220,
        render: (value, row) => value?.name || row?.filialName || "—",
      },
      {
        title: "Подписан",
        dataIndex: "isSigned",
        key: "isSigned",
        width: 110,
        render: (v) => (v ? "Да" : "Нет"),
      },
      {
        title: "Создан",
        dataIndex: "createdAt",
        key: "createdAt",
        width: 150,
        render: (v) => (v ? formatDateAsDate(v) : "—"),
      },
    ],
    []
  );

  const filterFields = [
    {
      title: "Филиал",
      key: "filialId",
      compareType: "equals",
      reducerKey: "filial",
      reducerArrayKey: "filials",
      reducerAction: getFilials,
      operandPosition: 1,
      optionLabelKey: "name",
      type: "normal",
      filterType: "normal",
    },
  ];

  return (
    <CRUDTable
      search={planDocumentCRUD.search}
      columns={columns}
      onClickCreateButton={() => push(PLAN_DOCUMENT_ROUTE("new"))}
      onRowClick={(record) => push(PLAN_DOCUMENT_ROUTE(record.id))}
      searchFields={[]}
      filterFields={filterFields}
      extraQuery={{
        includes: ["Filial", "State"],
      }}
      {...props}
    />
  );
}
